import React from 'react';

import {
  convertLocationParamsToFetchParams,
  usePolicies,
} from 'app/policies/api';
import {POLICIES_NEW_POLICY} from 'app/urls';
import {getPolicyName} from 'app/utils/fallbacks';
import {gt} from 'app/utils/i18n';

import {DashboardSidebarCollapsableList} from './DashboardSidebarCollapsableList';

type Props = {
  canCreate: boolean;
};

export const DashboardSidebarPoliciesList = ({canCreate}: Props) => (
  <DashboardSidebarCollapsableList
    icon="fa-umbrella"
    title={gt('Policies')}
    reduxKey="policies"
    watchModelChange="policy"
    showSearch={true}
    noResultsMessage={gt('No policies found')}
    canCreate={canCreate}
    createLink={POLICIES_NEW_POLICY}
    searchPlaceholder={gt('Search policy...')}
    useDataHook={usePolicies}
    paramsConverter={convertLocationParamsToFetchParams}
    itemNameProcessor={(policy) => getPolicyName(policy, true)}
  />
);
